import * as ChartControlBarUI from '../ChartControlBarUI';
import ChartTypeSelector from '../../ChartTypeSelector';
import { RETENTION_BASIC_VIEW_KEYS } from '../../../../utils/builder';
import { RetentionTableType } from '../../interfaces';
import { TimeUnit } from '../../../../utils/apollo/graphqlSchema';
import { useCallback } from 'react';
import {
  setChartSettingChurnAction,
  setSingleDayLabelAction,
} from '../../../../redux/slices/analyses';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { useAppDispatch } from '../../../../redux/hooks';
import { assertCondition } from '../../../../utils/types';
import { singleDayAllValue } from '../../../../utils/builder';
import RetentionUnitMenu from './RetentionUnitMenu/RetentionUnitMenu';
import ChartNumberTypeSelector from '../../ChartControlBar/ChartNumberTypeSelector';
import ChurnSelector from './ChurnSelector';
import { useChartContext } from '../../ChartContext';
interface IProps {
  analysisId: string;
}

const RetentionControlBar = ({ analysisId }: IProps) => {
  const dispatch = useAppDispatch();

  const {
    settings: { chartSettings },
    chartData,
    metadata: { query },
  } = useChartContext();
  const { singleDayLabel, isChurn } = chartSettings;
  assertCondition(query?.__typename === 'RetentionQuery');
  const { cohortUnit, view } = query;
  // narrow down chartData to IParsedChartDataRetention
  assertCondition(chartData?.queryType === QueryType.Retention);
  const { table } = chartData;

  const setIsChurn = useCallback(
    (newValue: boolean) => {
      dispatch(setChartSettingChurnAction({ analysisId, isChurn: newValue }));
    },
    [dispatch, analysisId],
  );

  const handleChangeSingleDayLabel = useCallback(
    (newSingleDayLabel: string) => {
      // avoid assign 'All' to singleDayLabel in chart settings
      const resultLabel =
        newSingleDayLabel === singleDayAllValue ? '' : newSingleDayLabel;

      dispatch(
        setSingleDayLabelAction({ analysisId, singleDayLabel: resultLabel }),
      );
    },
    [dispatch, analysisId],
  );

  return (
    <ChartControlBarUI.ControlBarRow>
      <ChartTypeSelector />
      <ChartNumberTypeSelector />
      {cohortUnit !== TimeUnit.AllTime && (
        <RetentionUnitMenu
          rowHeaders={table.rowHeaders}
          value={singleDayLabel}
          onChange={handleChangeSingleDayLabel}
          singleDayLabel={
            table.type === RetentionTableType.OverTime
              ? 'Unit - All'
              : 'Cohort - All'
          }
        />
      )}
      {RETENTION_BASIC_VIEW_KEYS.includes(view.key) && (
        <ChurnSelector isChurn={isChurn} changeChurn={setIsChurn} />
      )}
    </ChartControlBarUI.ControlBarRow>
  );
};

export default RetentionControlBar;
